/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpVaultTransaction } from './FuelUpVaultTransaction';
import {
    FuelUpVaultTransactionFromJSON,
    FuelUpVaultTransactionFromJSONTyped,
    FuelUpVaultTransactionToJSON,
    FuelUpVaultTransactionToJSONTyped,
} from './FuelUpVaultTransaction';

/**
 * 
 * @export
 * @interface FuelUpVaultState
 */
export interface FuelUpVaultState {
    /**
     * 
     * @type {string}
     * @memberof FuelUpVaultState
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FuelUpVaultState
     */
    userId: string;
    /**
     * Vault level (1-10)
     * @type {number}
     * @memberof FuelUpVaultState
     */
    level: number;
    /**
     * Amount of fuel currently in vault
     * @type {number}
     * @memberof FuelUpVaultState
     */
    storedFuel: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    maxCapacity: number;
    /**
     * 
     * @type {string}
     * @memberof FuelUpVaultState
     */
    evolutionTier: FuelUpVaultStateEvolutionTierEnum;
    /**
     * 
     * @type {Date}
     * @memberof FuelUpVaultState
     */
    lastDepositAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FuelUpVaultState
     */
    lastWithdrawAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FuelUpVaultState
     */
    nextEvolutionAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FuelUpVaultState
     */
    lastBonusAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    totalBonusEarned?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpVaultState
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    evolutionProgress?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    totalEvolutions?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    totalDeposited?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    totalWithdrawn?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    longestHoldStreak?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    currentBonusRate?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpVaultState
     */
    canEvolveNow?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    timeToNextEvolution?: number;
    /**
     * 
     * @type {Array<FuelUpVaultTransaction>}
     * @memberof FuelUpVaultState
     */
    recentTransactions?: Array<FuelUpVaultTransaction>;
    /**
     * 
     * @type {object}
     * @memberof FuelUpVaultState
     */
    currentVaultBonusTier?: object;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    lastDailyBonus?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    lastWeeklyBonus?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    lastMonthlyBonus?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    lifetimeBonusTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    fuelPricePerUsd?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultState
     */
    updatedAt?: number;
}


/**
 * @export
 */
export const FuelUpVaultStateEvolutionTierEnum = {
    basic: 'basic',
    evolved: 'evolved',
    ascended: 'ascended'
} as const;
export type FuelUpVaultStateEvolutionTierEnum = typeof FuelUpVaultStateEvolutionTierEnum[keyof typeof FuelUpVaultStateEvolutionTierEnum];


/**
 * Check if a given object implements the FuelUpVaultState interface.
 */
export function instanceOfFuelUpVaultState(value: object): value is FuelUpVaultState {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('storedFuel' in value) || value['storedFuel'] === undefined) return false;
    if (!('maxCapacity' in value) || value['maxCapacity'] === undefined) return false;
    if (!('evolutionTier' in value) || value['evolutionTier'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function FuelUpVaultStateFromJSON(json: any): FuelUpVaultState {
    return FuelUpVaultStateFromJSONTyped(json, false);
}

export function FuelUpVaultStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpVaultState {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'level': json['level'],
        'storedFuel': json['storedFuel'],
        'maxCapacity': json['maxCapacity'],
        'evolutionTier': json['evolutionTier'],
        'lastDepositAt': json['lastDepositAt'] == null ? undefined : (new Date(json['lastDepositAt'])),
        'lastWithdrawAt': json['lastWithdrawAt'] == null ? undefined : (new Date(json['lastWithdrawAt'])),
        'nextEvolutionAt': json['nextEvolutionAt'] == null ? undefined : (new Date(json['nextEvolutionAt'])),
        'lastBonusAt': json['lastBonusAt'] == null ? undefined : (new Date(json['lastBonusAt'])),
        'totalBonusEarned': json['totalBonusEarned'] == null ? undefined : json['totalBonusEarned'],
        'isActive': json['isActive'],
        'evolutionProgress': json['evolutionProgress'] == null ? undefined : json['evolutionProgress'],
        'totalEvolutions': json['totalEvolutions'] == null ? undefined : json['totalEvolutions'],
        'totalDeposited': json['totalDeposited'] == null ? undefined : json['totalDeposited'],
        'totalWithdrawn': json['totalWithdrawn'] == null ? undefined : json['totalWithdrawn'],
        'longestHoldStreak': json['longestHoldStreak'] == null ? undefined : json['longestHoldStreak'],
        'currentBonusRate': json['currentBonusRate'] == null ? undefined : json['currentBonusRate'],
        'canEvolveNow': json['canEvolveNow'] == null ? undefined : json['canEvolveNow'],
        'timeToNextEvolution': json['timeToNextEvolution'] == null ? undefined : json['timeToNextEvolution'],
        'recentTransactions': json['recentTransactions'] == null ? undefined : ((json['recentTransactions'] as Array<any>).map(FuelUpVaultTransactionFromJSON)),
        'currentVaultBonusTier': json['currentVaultBonusTier'] == null ? undefined : json['currentVaultBonusTier'],
        'lastDailyBonus': json['lastDailyBonus'] == null ? undefined : json['lastDailyBonus'],
        'lastWeeklyBonus': json['lastWeeklyBonus'] == null ? undefined : json['lastWeeklyBonus'],
        'lastMonthlyBonus': json['lastMonthlyBonus'] == null ? undefined : json['lastMonthlyBonus'],
        'lifetimeBonusTotal': json['lifetimeBonusTotal'] == null ? undefined : json['lifetimeBonusTotal'],
        'fuelPricePerUsd': json['fuelPricePerUsd'] == null ? undefined : json['fuelPricePerUsd'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function FuelUpVaultStateToJSON(json: any): FuelUpVaultState {
    return FuelUpVaultStateToJSONTyped(json, false);
}

export function FuelUpVaultStateToJSONTyped(value?: FuelUpVaultState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'level': value['level'],
        'storedFuel': value['storedFuel'],
        'maxCapacity': value['maxCapacity'],
        'evolutionTier': value['evolutionTier'],
        'lastDepositAt': value['lastDepositAt'] == null ? undefined : ((value['lastDepositAt']).toISOString()),
        'lastWithdrawAt': value['lastWithdrawAt'] == null ? undefined : ((value['lastWithdrawAt']).toISOString()),
        'nextEvolutionAt': value['nextEvolutionAt'] == null ? undefined : ((value['nextEvolutionAt']).toISOString()),
        'lastBonusAt': value['lastBonusAt'] == null ? undefined : ((value['lastBonusAt']).toISOString()),
        'totalBonusEarned': value['totalBonusEarned'],
        'isActive': value['isActive'],
        'evolutionProgress': value['evolutionProgress'],
        'totalEvolutions': value['totalEvolutions'],
        'totalDeposited': value['totalDeposited'],
        'totalWithdrawn': value['totalWithdrawn'],
        'longestHoldStreak': value['longestHoldStreak'],
        'currentBonusRate': value['currentBonusRate'],
        'canEvolveNow': value['canEvolveNow'],
        'timeToNextEvolution': value['timeToNextEvolution'],
        'recentTransactions': value['recentTransactions'] == null ? undefined : ((value['recentTransactions'] as Array<any>).map(FuelUpVaultTransactionToJSON)),
        'currentVaultBonusTier': value['currentVaultBonusTier'],
        'lastDailyBonus': value['lastDailyBonus'],
        'lastWeeklyBonus': value['lastWeeklyBonus'],
        'lastMonthlyBonus': value['lastMonthlyBonus'],
        'lifetimeBonusTotal': value['lifetimeBonusTotal'],
        'fuelPricePerUsd': value['fuelPricePerUsd'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

